'use strict';

define('fastaction_config',['jquery.amd'], function ($) {
  var regex = {
    localhost: /^https?:\/\/localhost/i,
    notSSL: /^http:/i,
    trailingSlash: /\/+$/
  };

  function form() {
    return $('.ngp-form');
  }

  function url() {
    var u = form().data('fastactionEndpoint') || 'https://fastaction.ngpvan.com';
    /* No longer coerce endpoint to use SSL because it's harder to debug.
     if (!regex.localhost.test(u) && regex.notSSL.test(u)) {
     u = u.replace(regex.notSSL, 'https:');
     }*/
    return u.replace(regex.trailingSlash, '');
  }

  function identity() {
    return url() + '/api/v1/identity';
  }

  function profile(id) {
    return url() + '/api/v1/profile/' + id;
  }

  function loginProfile(id) {
    return url() + '/api/v1/profile/' + id + '/log_in';
  }

  function forms() {
    return url() + '/api/v1/forms/';
  }

  return {
    urls: {
      base: url,
      identity: identity,
      profile: profile,
      forms: forms,
      loginProfile: loginProfile
    }
  };
});

